import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './translate.service';

@Pipe({
  name: 'translate'
})

export class TranslatePipe implements PipeTransform {

  constructor(private _translate: TranslateService) {}

  transform(value: string, args: any[]): any {
    if (!value) {
      return;
    }

    return this._translate.instant(value);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/translate/translate.pipe.ts